import { FileText } from "lucide-react";
import { format } from "date-fns";
import { DocumentActions } from "./DocumentActions";
import { Card } from "@/components/ui/card";

interface Document {
  id: string;
  name: string;
  size: number;
  type: string;
  path: string;
  created_at: string;
  user_id: string;
}

interface DocumentListProps {
  documents: Document[];
  onPreview: (path: string) => void;
  onDownload: (path: string, fileName: string) => void;
  onDelete: (id: string, path: string) => void;
}

export const DocumentList = ({
  documents,
  onPreview,
  onDownload,
  onDelete,
}: DocumentListProps) => {
  return (
    <Card className="p-6 bg-[#222222] border-white/10">
      {documents.length === 0 ? (
        <p className="text-muted-foreground">No documents have been uploaded yet.</p>
      ) : (
        <div className="space-y-4">
          {documents.map((doc) => (
            <div key={doc.id} className="flex items-center justify-between border border-white/10 rounded-lg p-4">
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-primary" />
                <div>
                  <p className="text-white">{doc.name}</p>
                  <p className="text-sm text-gray-400">
                    Uploaded on {format(new Date(doc.created_at), 'PPP')}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <p className="text-sm text-gray-400 mr-4">
                  {(doc.size / 1024 / 1024).toFixed(2)} MB
                </p>
                <DocumentActions
                  onPreview={() => onPreview(doc.path)}
                  onDownload={() => onDownload(doc.path, doc.name)}
                  onDelete={() => onDelete(doc.id, doc.path)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};